import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_CAPITALSTATE}`

const fetchBalance = (query) => http.get(`${api}/operation/recaudos`, { params: { ...query } })

export {
  fetchBalance
}
